export default __webpack_public_path__ + "static/media/08.546b98a5.jpg";